import React from 'react';
import { TextField, Button } from '@material-ui/core';
import DateOfBirthInput from './DateOfBirthInput';
import PrimaryButton from '../../../view/common/component/PrimaryButton';

export default function ExistingUserPage2({
    dateOfBirth,
    setDateOfBirth,
    dateOfBirthErrorMessage,
    dateOfBirthValidated,
    hasDateOfBirthError,
    parentEmail,
    setParentEmail,
    hasParentEmailError,
    parentEmailHelperText,
    onSubmit,
    onGoBack,
    isSubmitting
}) {
    return (
        <div
            className="existing-user-page-2"
            data-testid="existing-user-page-2"
        >
            <h2 className="terms-of-use-title">
                Parent or legal guardian consent required
            </h2>
            <p>
                Accounts for users under the age of 16 must be verified by a
                parent or legal guardian.
            </p>
            <p>
                An email will be sent to your parent or legal guardian with a
                link to our consent form.{' '}
                <b>
                    If we do not receive consent in 24 hours, your account will
                    be locked until we receive consent.
                </b>
            </p>
            <DateOfBirthInput
                dateOfBirth={dateOfBirth}
                setDateOfBirth={setDateOfBirth}
                errorMessage={
                    dateOfBirthValidated
                        ? 'Must be under 16'
                        : dateOfBirthErrorMessage
                }
                hasError={hasDateOfBirthError}
            />
            <div className="parent-email-input-container">
                <h4 className="parental-consent-header">
                    Parent or guardian email address
                </h4>
                <TextField
                    className="parent-email-input"
                    type="text"
                    label={parentEmail ? ' ' : 'Parent or legal guardian email'}
                    aria-label="parent or legal guardian email"
                    value={parentEmail}
                    onChange={event => {
                        setParentEmail(event.target.value);
                    }}
                    error={hasParentEmailError}
                    helperText={
                        hasParentEmailError ? parentEmailHelperText : ' '
                    }
                    InputLabelProps={{
                        shrink: false
                    }}
                />
            </div>
            <div className="consent-button-container">
                <PrimaryButton
                    onClick={onSubmit}
                    showActivity={isSubmitting}
                    testid="page-2"
                >
                    Submit
                </PrimaryButton>
                <Button
                    onClick={onGoBack}
                    className="th-secondary-button"
                    data-testid="secondary-button"
                >
                    Go Back
                </Button>
            </div>
        </div>
    );
}
